// Mock data structure specifically designed for get-model-front UI components

// Mock data for training records list
const mockModelListData = [
  {
    id: 'model_001',
    projectName: 'Credit Risk Assessment',
    userName: 'John Doe',
    createTime: '2023-10-15 08:30:00',
    status: 3, // Success
    coreData: 'Accuracy: 95%'
  },
  {
    id: 'model_002',
    projectName: 'Customer Churn Prediction',
    userName: 'Jane Smith',
    createTime: '2023-09-22 14:45:00',
    status: 2, // Running
  },
  {
    id: 'model_003',
    projectName: 'Product Recommendation Engine',
    userName: 'Bob Johnson',
    createTime: '2023-08-10 11:15:00',
    status: 4, // Failed
  },
  {
    id: 'model_004',
    projectName: 'Loan Approval',
    userName: 'Diana Prince',
    createTime: '2023-08-05 16:20:00',
    status: 3, // Success
    coreData: 'Accuracy: 92%'
  },
  {
    id: '176',
    projectName: 'Customer Segmentation Model',
    userName: 'Test User',
    createTime: '2025-03-15 10:00:00',
    status: 3,
    coreData: 'Accuracy: 88%'
  },
  {
    id: '302',
    projectName: 'GN3.1 Neural Tree Web (NT1.0 + NT1.1)',
    userName: 'Test User',
    createTime: '2025-07-28 09:00:00',
    status: 3,
    coreData: 'Layers: 4, Neural Trees: 2'
  }
,
  {
    id: '299',
    projectName: 'GN3.1 Neural Tree Web (NT1.0 + NT1.1)',
    userName: 'Test User',
    createTime: '2025-07-28 09:00:00',
    status: 3,
    coreData: 'Layers: 4, Neural Trees: 2'
  },
  {
    id: '310',
    projectName: 'GN3.1 Neural Tree Web (NT1.0 + NT1.1 + NT1.2)',
    userName: 'Test User',
    createTime: '2026-08-10 09:00:00',
    status: 3,
    coreData: 'Layers: 4, Neural Trees: 3'
  },
  {
    id: '312',
    projectName: 'GN3.1 Neural Tree Web (NT1.0 + NT1.1) - Multi-path',
    userName: 'Test User',
    createTime: '2026-08-21 09:00:00',
    status: 3,
    coreData: 'Layers: 4, Neural Trees: 2, Multi-path support'
  }
];

// Mock data for historical predictions
const mockHistoricalPredictions = [
  {
    id: '1',
    modelName: 'Credit Risk Assessment',
    taskId: 'task_001',
    fileName: 'customer_data_v1.csv',
    createTime: '2023-10-20 09:15:00',
    status: 3, // Success
    resultPath: '/get/predict/download/localPredict/task_001',
    reportPath: '/get/predict/download/localReport/task_002'
  },
  {
    id: '2',
    modelName: 'Credit Risk Assessment',
    taskId: 'task_002',
    fileName: 'customer_data_v2.csv',
    createTime: '2023-10-21 14:30:00',
    status: 3, // Success
    resultPath: '/get/predict/download/localPredict/task_002',
    reportPath: '/get/predict/download/localReport/task_002'
  }
];

// Mock data for model explanation - GN3.1 enhanced
const mockExplanationData = {
  ai_analysis: `## Model Analysis
  This is a sample analysis.`,

  // ========== GN3.1: Neural-Tree Web Metadata (Section A) ==========
  neural_tree_meta: [
    { lyl: "1.1", lvl: 1, dvd: 1, dl1: 0, rnl: 1, nmx: 351, bmx: 126.0, afa: 0.358, nobs: 351, nbd: 126.0, afr: 0.358, rmi_fs: 1, fmi_fs: 1, fbn_fs: 1, onm_fs: "owo_pvl000_0", abdo_fs: 0.960, ml1n_fs: -1.0, dmx: 2, oco: -1.074, onm_fn: null, wip: 2 }
  ],

  // ========== GN3.1: Web Performance Summary (Section A, 20260810 update) ==========
  overall_portfolio_performance: 0.921411,
  first_layer_performance: 0.894039,

  // Rows/Mean of Y + Benchmark (training / cross-validation)
  training_rows: 244,
  training_mean_y: 0.36475409836,
  training_benchmark_performance: 0.87415730337,
  cross_validation_rows: 106,
  cross_validation_mean_y: 0.33962264151,
  cross_validation_benchmark_performance: 0.9246031746,
  cross_validation_total_performance: 0.95476190476,
  cross_validation_first_layer_performance: 0.9246031746,

  // Neural-Tree Web structure - 5 trees across 2 levels
  layers_of_neural_tree_web: 3,
  number_of_neural_trees: 5,
  levels_of_neural_trees: 2,

  // Layer contributions (percentage breakdown) + per-layer total performance
  layer_contributions: [
    { layer_id: 1, contribution_percentage: 40, training_performance: 0.8742, cross_validation_performance: 0.9246 },
    { layer_id: 2, contribution_percentage: 35, training_performance: 0.8746, cross_validation_performance: 0.9238 },
    { layer_id: 3, contribution_percentage: 25, training_performance: 0.9214, cross_validation_performance: 0.9548 }
  ],

  // ========== GN3.1: Layer Details (Section B) ==========
  layer_details: [
    {
      layer_id: 1,
      neural_trees_count: 5,
      contributing_weights: [
        { neural_tree_id: "1.1", weight_percentage: 45 },
        { neural_tree_id: "1.2", weight_percentage: 35 },
        { neural_tree_id: "1.3", weight_percentage: 20 },
        { neural_tree_id: "2.1", weight_percentage: 55 },
        { neural_tree_id: "2.2", weight_percentage: 45 }
      ],
      performance_range: { min: 0.698, max: 0.894 }
    },
    {
      layer_id: 2,
      neural_trees_count: 5,
      contributing_weights: [
        { neural_tree_id: "1.1", weight_percentage: 50 },
        { neural_tree_id: "1.2", weight_percentage: 40 },
        { neural_tree_id: "1.3", weight_percentage: 25 },
        { neural_tree_id: "2.1", weight_percentage: 60 },
        { neural_tree_id: "2.2", weight_percentage: 50 }
      ],
      performance_range: { min: 0.650, max: 0.780 }
    },
    {
      layer_id: 3,
      neural_trees_count: 5,
      contributing_weights: [
        { neural_tree_id: "1.1", weight_percentage: 30 },
        { neural_tree_id: "1.2", weight_percentage: 25 },
        { neural_tree_id: "1.3", weight_percentage: 15 },
        { neural_tree_id: "2.1", weight_percentage: 40 },
        { neural_tree_id: "2.2", weight_percentage: 35 }
      ],
      performance_range: { min: 0.550, max: 0.680 }
    }
  ],

  // ========== Legacy layers structure (backward compatible) ==========
  layers: [
    {
      layer_id: 1,
      performance: 0.894,
      intervals: { 'I': { performance: 0.90 }, 'E': { performance: 0.88 } }
    },
    {
      layer_id: 2,
      performance: 0.750,
      intervals: { 'IU': { performance: 0.81 }, 'ID': { performance: 0.69 } }
    }
  ]
};

// Enhanced mock data for decision tree visualization
// Structure: Gen -> Tree -> Layer -> Branch -> Feature -> Sign -> Form
const mockTreeData = {
  key: 'Neural Tree Web',
  type: 'root',
  children: [
    // ================= LEVEL 1 =================
    {
      key: 'Gen 1',
      type: 'gen',
      level: 1,
      children: [
        // --- NT 1.1 (Neural Tree 1.1) ---
        {
          key: 'NT 1.1',
          type: 'tree',
          treeId: '1.1',
          weight: 0.45,
          children: [
            {
              key: 'Layer 1',
              type: 'layer',
              performance: 0.894,
              label_ratio: '60:40',
              children: [
                {
                  key: 'Branch I',
                  type: 'branch',
                  performance: 0.901,
                  label_ratio: '55:45',
                  children: [
                    {
                      key: 'V5',
                      type: 'feature',
                      weight: 0.145,
                      polarity: 'p',
                      rawValue: 0.35,
                      children: [
                        {
                          key: 'V5_f0',
                          type: 'gen',
                          children: [
                            {
                              key: 'P (Positive)',
                              type: 'sign',
                              polarity: 'p',
                              children: [
                                {
                                  key: 'SS (Piecewise)',
                                  type: 'form',
                                  weight: 0.60,
                                  criticalRange: '0.45 - 1.80',
                                  paramI: 0.45,
                                  paramII: 1.80,
                                  prediction: 0.65
                                },
                                {
                                  key: 'LS (Linear)',
                                  type: 'form',
                                  weight: 0.40,
                                  criticalRange: '0.45 - 0.25',
                                  paramI: 0.45,
                                  paramII: 0.25,
                                  prediction: 0.72
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    },
                    {
                      key: 'V24',
                      type: 'feature',
                      weight: 0.041,
                      polarity: 'p',
                      rawValue: 0.23,
                      children: [
                        {
                          key: 'V24_f0',
                          type: 'gen',
                          children: [
                            {
                              key: 'P (Positive)',
                              type: 'sign',
                              polarity: 'p',
                              children: [
                                {
                                  key: 'SS (Piecewise)',
                                  type: 'form',
                                  weight: 1.0,
                                  criticalRange: '0.23 - 2.59',
                                  paramI: 0.23,
                                  paramII: 2.59,
                                  prediction: 0.65
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        // --- NT 1.2 (Neural Tree 1.2) ---
        {
          key: 'NT 1.2',
          type: 'tree',
          treeId: '1.2',
          weight: 0.35,
          children: [
            {
              key: 'Layer 1',
              type: 'layer',
              performance: 0.875,
              label_ratio: '55:45',
              children: [
                {
                  key: 'Branch A',
                  type: 'branch',
                  performance: 0.888,
                  label_ratio: '50:50',
                  children: [
                    {
                      key: 'V8',
                      type: 'feature',
                      weight: 0.090,
                      polarity: 'n',
                      rawValue: 1.50,
                      children: [
                        {
                          key: 'V8_f0',
                          type: 'gen',
                          children: [
                            {
                              key: 'N (Negative)',
                              type: 'sign',
                              polarity: 'n',
                              children: [
                                {
                                  key: 'VS (V-Shape)',
                                  type: 'form',
                                  weight: 0.80,
                                  criticalRange: '0.23 - 2.59',
                                  paramI: 0.23,
                                  paramII: 2.59,
                                  prediction: 0.65
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        // --- NT 1.3 (Neural Tree 1.3) ---
        {
          key: 'NT 1.3',
          type: 'tree',
          treeId: '1.3',
          weight: 0.20,
          children: [
            {
              key: 'Layer 1',
              type: 'layer',
              performance: 0.856,
              label_ratio: '65:35',
              children: [
                {
                  key: 'Branch X',
                  type: 'branch',
                  performance: 0.856,
                  label_ratio: '65:35',
                  children: [
                    {
                      key: 'V10',
                      type: 'feature',
                      weight: 0.145,
                      polarity: 'p',
                      rawValue: 0.80,
                      children: [
                        {
                          key: 'V10_f0',
                          type: 'gen',
                          children: [
                            {
                              key: 'P (Positive)',
                              type: 'sign',
                              polarity: 'p',
                              children: [
                                {
                                  key: 'LS (Linear)',
                                  type: 'form',
                                  weight: 0.70,
                                  criticalRange: '0.23 - 2.59',
                                  paramI: 0.23,
                                  paramII: 2.59,
                                  prediction: 0.65
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    },
    // ================= LEVEL 2 =================
    {
      key: 'Gen 2',
      type: 'gen',
      level: 2,
      children: [
        // --- NT 2.1 (Neural Tree 2.1) ---
        {
          key: 'NT 2.1',
          type: 'tree',
          treeId: '2.1',
          weight: 0.55,
          children: [
            {
              key: 'Layer 1',
              type: 'layer',
              performance: 0.750,
              label_ratio: '30:70',
              children: [
                {
                  key: 'Branch B',
                  type: 'branch',
                  performance: 0.810,
                  label_ratio: '45:55',
                  children: [
                    {
                      key: 'V2',
                      type: 'feature',
                      weight: 0.145,
                      polarity: 'p',
                      rawValue: 0.45,
                      children: [
                        {
                          key: 'V2_f0',
                          type: 'gen',
                          children: [
                            {
                              key: 'P (Positive)',
                              type: 'sign',
                              polarity: 'p',
                              children: [
                                {
                                  key: 'SS (Piecewise)',
                                  type: 'form',
                                  weight: 1.0,
                                  criticalRange: '0.15 - 1.20',
                                  paramI: 0.15,
                                  paramII: 1.20,
                                  prediction: 0.72
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        // --- NT 2.2 (Neural Tree 2.2) ---
        {
          key: 'NT 2.2',
          type: 'tree',
          treeId: '2.2',
          weight: 0.45,
          children: [
            {
              key: 'Layer 1',
              type: 'layer',
              performance: 0.698,
              label_ratio: '40:60',
              children: [
                {
                  key: 'Branch C',
                  type: 'branch',
                  performance: 0.720,
                  label_ratio: '35:65',
                  children: [
                    {
                      key: 'V3',
                      type: 'feature',
                      weight: 0.112,
                      polarity: 'n',
                      rawValue: 0.10,
                      children: [
                        {
                          key: 'V3_f0',
                          type: 'gen',
                          children: [
                            {
                              key: 'N (Negative)',
                              type: 'sign',
                              polarity: 'n',
                              children: [
                                {
                                  key: 'SS (Piecewise)',
                                  type: 'form',
                                  weight: 1.0,
                                  criticalRange: '0.05 - 0.85',
                                  paramI: 0.05,
                                  paramII: 0.85,
                                  prediction: 0.58
                                }
                              ]
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};

// Mock organizations data
const mockOrganizations = [
  { id: 'org_000', name: 'System Organization', code: 'SYSORG', adminUserId: 'user_000', adminUserName: 'System Admin' },
  { id: 'org_001', name: 'Mock Organization 1', code: 'MO1', adminUserId: 'user_001', adminUserName: 'Org Admin 1' },
  { id: 'org_002', name: 'Mock Organization 2', code: 'MO2', adminUserId: 'user_002', adminUserName: 'Org Admin 2' }
];

// Mock users data
const mockUsers = [
  { id: 'user_000', loginName: 'sysadmin', userName: 'System Admin', password: 'password', orgId: 'org_000', orgName: 'System Organization', userType: 'sysadmin' },
  { id: 'user_001', loginName: 'orgadmin1', userName: 'Org Admin 1', password: 'password', orgId: 'org_001', orgName: 'Mock Organization 1', userType: 'admin' },
  { id: 'user_002', loginName: 'user1', userName: 'Regular User 1', password: 'password', orgId: 'org_001', orgName: 'Mock Organization 1', userType: 'user' },
  { id: 'user_003', loginName: 'orgadmin2', userName: 'Org Admin 2', password: 'password', orgId: 'org_002', orgName: 'Mock Organization 2', userType: 'admin' },
  { id: 'user_004', loginName: 'user2', userName: 'Regular User 2', password: 'password', orgId: 'org_002', orgName: 'Mock Organization 2', userType: 'user' }
];

// Mock data for the Neural Route Summary block (GN3.1 20260810 update)
const mockNeuralRouteData = {
  trees: [
    {
      neural_tree_id: "NT1.0",
      levels: [1, 2, 3, 4],
      routes: [
        {
          blst: "I-UU2",
          fraction: 0.24777100358,
          y_rate: 0.89075266499,
          neural_branch: ["I", "I-U", "I-UU", "I-UU2"],
          branch_weight: [0.8674284623, 0.1325715377, 0, 0],
          get_training: [0.87555555556, 0.74933333333, 0.85964912281, 0.85964912281],
          benchmark_training: [0.87555555556, 0.74133333333, 0.85964912281, 0.85964912281],
          get_cross_validation: [0.9246031746, 0.87058823529, null, null],
          benchmark_cross_validation: [0.9246031746, 0.88235294118, null, null]
        },
        {
          blst: "I-DDD",
          fraction: 0.26811619717,
          y_rate: 0.016650368065,
          neural_branch: ["I", "I-D", "I-DD", "I-DDD"],
          branch_weight: [0.17893050514, 0.6130686355, 0.20800085936, 0],
          get_training: [0.87555555556, 0.42896551724, 0.68791208791, 0.90769230769],
          benchmark_training: [0.87555555556, 0.42896551724, 0.1032967033, -0.78461538462],
          get_cross_validation: [0.9246031746, -0.15384615384, 0.37931034483, 0.38461538462],
          benchmark_cross_validation: [0.9246031746, -0.15384615384, 0.24137931034, 0.076923076924]
        }
      ]
    },
    {
      neural_tree_id: "NT1.1",
      levels: [1, 2, 3, 4],
      routes: [
        {
          blst: "I-UU2",
          fraction: 0.20350100164,
          y_rate: 0.85108931462,
          neural_branch: ["I", "I-U", "I-UU", "I-UU2"],
          branch_weight: [0.8674284646, 0.1325715354, 0, 0],
          get_training: [0.87555555556, 0.74933333333, 0.90070921986, 0.90070921986],
          benchmark_training: [0.87555555556, 0.74133333333, 0.90070921986, 0.90070921986],
          get_cross_validation: [0.9246031746, 0.87058823529, null, null],
          benchmark_cross_validation: [0.9246031746, 0.88235294118, null, null]
        }
      ]
    }
  ]
};

export { mockModelListData, mockTreeData, mockHistoricalPredictions, mockExplanationData, mockNeuralRouteData, mockOrganizations, mockUsers };
